<form class="follow-up" *ngIf="enterWeightForm" [formGroup]="enterWeightForm" (submit)="onSubmitConsultation($event)">
  <div class="follow-up-fields">
    <div class="follow-up-fields-wrapper">
      <div class="follow-up-field follow-up-field--visit-date">
        <app-rc-input
          (changeValue)="nextVisitDateUpdate()"
          [field]="enterWeightFields['visitDate']"
          formControlName="visitDate"
          [formControl]="$any(enterWeightForm.get('visitDate'))"
        >
        </app-rc-input>
      </div>

      <div class="follow-up-field follow-up-field--weight">
        <app-rc-input [field]="enterWeightFields['weight']" formControlName="weight" [formControl]="$any(enterWeightForm.get('weight'))">
        </app-rc-input>
      </div>
    </div>

    <div class="clear"></div>

    <div class="follow-up-field--information">
      <div class="rc-icon rc-icon--alert follow-up-field--information_icon"></div>
      <span class="follow-up-field--information_label">
        <ng-container i18n="@@follow-up_info-label">Weight should be between</ng-container>
        <span class="kilo-label" *ngIf="!isLoading"> {{ minWeight }} </span>
        <span [class.loading]="isLoading"></span>
        <span class="kilo-label"> {{ weightSuffix }} </span>
        <ng-container i18n="@@and">and</ng-container>
        <span class="kilo-label" *ngIf="!isLoading"> {{ maxWeight }} </span>
        <span [class.loading]="isLoading"></span>
        <span class="kilo-label"> {{ weightSuffix }} </span>
      </span>
    </div>
  </div>

  <div class="follow-up-footer">
    <button class="rc-button rc-button--filled-small" id="saveFollowUpChanges" type="submit" [disabled]="enterWeightForm.invalid">
      <span class="rc-button__title" i18n="@@action_save-changes">Save changes</span>
    </button>
  </div>
</form>
